let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8pE8S")).then(() => parcelRequire('av4P2'));